import {
  GET_USER_ADDRESSES,
  ADD_USER_ADDRESS,
  EDIT_USER_ADDRESS,
  DELETE_USER_ADDRESS,
} from 'modules/dashboard/store/constants';

export const getUserAddresses = () => ({
  type: GET_USER_ADDRESSES,
});

export const addUserAddresses = ({
  firstName,
  lastName,
  addressLine1,
  addressLine2,
  city,
  state,
  country,
  pincode,
}) => ({
  type: ADD_USER_ADDRESS,
  payload: {
    firstName,
    lastName,
    addressLine1,
    addressLine2,
    city,
    state,
    country,
    pincode,
  },
});

export const editUserAddresses = ({
  _id,
  firstName,
  lastName,
  addressLine1,
  addressLine2,
  city,
  state,
  country,
  pincode,
}) => ({
  type: EDIT_USER_ADDRESS,
  payload: {
    _id,
    firstName,
    lastName,
    addressLine1,
    addressLine2,
    city,
    state,
    country,
    pincode,
  },
});

export const deleteUserAddresses = (addressId) => ({
  type: DELETE_USER_ADDRESS,
  payload: {
    addressId,
  },
});
